import { useEffect, useState } from 'react'
import { Keyboard } from 'react-native'

/**
 * Tracks whether the software keyboard is currently shown (native only).
 *
 * Driven by the keyboard show/hide events rather than input focus, so the
 * value follows the keyboard itself: dismissing the keyboard (e.g. Android
 * back button) flips it back to `false` even if a TextInput keeps focus.
 *
 * On web the keyboard events never fire, so this stays `false` — callers
 * relying on it simply don't change behaviour on web.
 */
export const useKeyboardVisible = (): boolean => {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const show = Keyboard.addListener('keyboardDidShow', () => setVisible(true))
    const hide = Keyboard.addListener('keyboardDidHide', () => setVisible(false))
    return () => {
      show.remove()
      hide.remove()
    }
  }, [])

  return visible
}
